export const footerMenuFixture = [
  {
    id: 1,
    label: 'About',
    link: '#',
    external: false,
    children: [
      {
        id: 7,
        label: 'History',
        link: '/skels/about/history.html',
        external: false,
      },
      {
        id: 8,
        label: 'Figures',
        link: '/skels/about/figures.html',
        external: false,
      },
      {
        id: 9,
        label: 'Values',
        link: '/skels/about/values.html',
        external: false,
      },
      {
        id: 10,
        label: 'BCFN Foundation',
        link: '/skels/about/fondazione-bcfn.html',
        external: false,
      },
      {
        id: 11,
        label: 'Position',
        link: '/skels/about/position.html',
        external: false,
      },
      {
        id: 12,
        label: 'Family Company',
        link: '/skels/about/family-company.html',
        external: false,
      },
      {
        id: 13,
        label: 'Ask us',
        link: '/skels/about/get-in-touch.html',
        external: false,
      },
      {
        id: 14,
        label: 'Get in touch',
        link: '/skels/about/get-in-touch.html',
        external: false,
      },
    ],
  },
  {
    id: 2,
    label: 'Mission',
    link: '#',
    external: false,
    children: [
      {
        id: 15,
        label: 'Good for You',
        link: '#',
        external: false,
      },
      {
        id: 16,
        label: 'Good for the Planet',
        link: '#',
        external: false,
      },
      {
        id: 17,
        label: 'Sustainability',
        link: '#',
        external: false,
      },
    ],
  },
  {
    id: 3,
    label: 'Brands',
    link: '#',
    external: false,
    children: [
      {
        id: 18,
        label: 'Barilla',
        link: '#',
        external: false,
      },
      {
        id: 19,
        label: 'Mulino Bianco',
        link: '#',
        external: false,
      },
      {
        id: 20,
        label: 'Harrys',
        link: '#',
        external: false,
      },
      {
        id: 21,
        label: 'Pan di Stelle',
        link: '#',
        external: false,
      },
      {
        id: 22,
        label: 'Wasa',
        link: '#',
        external: false,
      },
      {
        id: 23,
        label: 'Other brands',
        link: '#',
        external: false,
      },
    ],
  },
  {
    id: 4,
    label: 'News',
    link: '#',
    external: false,
    children: [
      {
        id: 24,
        label: 'Articles',
        link: '#',
        external: false,
      },
      {
        id: 25,
        label: 'Press releases',
        link: '#',
        external: false,
      },
      {
        id: 26,
        label: 'Videos',
        link: '#',
        external: false,
      },
      {
        id: 27,
        label: 'Reports',
        link: '#',
        external: false,
      },
      {
        id: 28,
        label: 'In the news',
        link: '#',
        external: false,
      },
      {
        id: 29,
        label: 'Media resources',
        link: '#',
        external: false,
      },
    ],
  },
  {
    id: 5,
    label: 'Careers',
    link: '#',
    external: false,
    children: [
      {
        id: 30,
        label: 'Working at Barilla',
        link: '#',
        external: false,
      },
      {
        id: 31,
        label: 'Diversity & Inclusion',
        link: '#',
        external: false,
      },
      {
        id: 31,
        label: 'Smart working',
        link: '#',
        external: false,
      },
      {
        id: 32,
        label: 'Job opprtunities',
        link: '#',
        external: false,
      },
    ],
  },
  {
    id: 6,
    label: 'More about us',
    link: false,
    external: false,
    children: [
      {
        id: 33,
        label: 'Corporate governance',
        link: '#',
        external: false,
      },
      {
        id: 34,
        label: 'Code of ethics',
        link: '#',
        external: true,
      },
      {
        id: 35,
        label: 'Fraud control policy',
        link: '#',
        external: false,
      },
      {
        id: 36,
        label: 'Privacy policy',
        link: '#',
        external: false,
      },
      {
        id: 37,
        label: 'Barilla GDPR policy',
        link: '#',
        external: false,
      },
      {
        id: 38,
        label: 'Disclamer',
        link: '#',
        external: false,
      },
      {
        id: 39,
        label: 'Barilla CFN',
        link: '#',
        external: true,
      },
      {
        id: 40,
        label: 'Historical archive',
        link: '#',
        external: true,
      },
    ],
  },
]

export const footerSocialsFixture = [
  {
    icon: 'twitter',
    name: 'Twitter',
    link: 'https://twitter.com/barillagroup',
  },
  {
    icon: 'youtube',
    name: 'YouTube',
    link: 'https://www.youtube.com/user/BarillaGroup',
  },
  {
    icon: 'linkedin-in',
    name: 'Linkedin In',
    link: 'https://www.linkedin.com/company/barilla_group',
  }
]

export const footerLangFixture = [
  {
    code: 'en',
    code3: 'ENG',
    label: 'English',
    link: '#en',
    current: true,
  },
  {
    code: 'it',
    code3: 'ITA',
    label: 'Italiano',
    link: '#it',
    current: false,
  },
]
